module.exports = __webpack_public_path__ + "static/banner01-6789e658c6bf722b85e856cc57e332c4.png";